import { enumCurrencyCode, enumUnit } from '@rematter/frontend-lib-api-client';
import { fullLoadFragment } from '@rematter/modules/customer-portal/_graphql/fragmentsLoad';
import { maybe, calculateNetWeight } from '@rematter/ui-web';

import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';
import { QueryAtomResult } from '~/shared/providers/api/createQueryAtomFactory';

export type EntityLoadRecord = QueryAtomResult<
  typeof loadListByEntityQueryAtom
>[number];
export type EntityLoadLineItemRecord = EntityLoadRecord['lineItems'][number];

export const loadListByEntityQueryAtom = createQueryAtomFactory(
  'customerPortal.loadListByEntity',
  (params: { bookingIds?: string | string[]; purchaseOrderId?: string }) => ({
    loads: {
      __args: {
        filter: {
          bookingIds: maybe(params.bookingIds, (id) =>
            Array.isArray(id) ? id : [id],
          ),
          salesOrderId: params.purchaseOrderId,
        },
        pagination: {
          limit: 100,
          offset: 0,
        },
      },
      entries: fullLoadFragment,
    },
  }),
  {
    select: ({ loads }) =>
      loads.entries.map((load) => ({
        id: load.id,
        loadNumber: load.documentNumber,
        status: load.status,
        netWeight: calculateNetWeight(
          load.heavyWeight
            ? { ...load.heavyWeight, __typename: 'Weight' as const }
            : null,
          load.lightWeight
            ? { ...load.lightWeight, __typename: 'Weight' as const }
            : null,
        ) ?? {
          value: 0,
          unit: enumUnit.Pounds,
          __typename: 'Weight' as const,
        },
        totalPrice: {
          amount: load.lineItems.reduce(
            (acc, lineItem) => acc + (lineItem.estimatedPrice?.amount ?? 0),
            0,
          ),
          currencyCode: enumCurrencyCode.USD,
        },
        recyclerFiles: load.recyclerFiles,
        lineItems: load.lineItems.map((lineItem) => ({
          ...lineItem,
          estimatedPrice: maybe(lineItem.estimatedPrice),
          material: lineItem.item,
        })),
      })),
  },
);
